module.exports = __webpack_public_path__ + "img/comment_1_2.15bd79ca.jpg";